export default "__VITE_ASSET__cNdVKVxz__"